import PropTypes from 'prop-types';
import { cloneElement, createElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

const HTML_MARKUP_OPTIONS = { button: 'button', a: 'a' };

const Button = forwardRef(
  (
    {
      as = 'button',
      buttonTextClassName,
      children = null,
      className,
      full = false,
      htmlType = 'button',
      icon = null,
      ...rest
    },
    ref
  ) =>
    createElement(
      HTML_MARKUP_OPTIONS[as] || 'button',
      {
        type: as === 'a' ? null : htmlType,
        className: twMerge(
          'group flex min-w-max cursor-pointer select-none flex-col w-[104px] h-[70px] items-center gap-2 no-underline transition-all ease-in',
          full && 'w-full',
          className
        ),
        ref,
        ...rest,
      },
      <>
        <span
          className={twMerge(
            'flex h-10 w-10 items-center justify-center rounded-full bg-primary-300 group-hover:bg-primary-400'
          )}
        >
          {icon &&
            cloneElement(icon, {
              size: 'size1',
              'aria-hidden': true,
              className: 'text-neutral-high-100',
            })}
        </span>
        <Text
          className={twMerge(
            'whitespace-nowrap text-center font-medium',
            buttonTextClassName
          )}
          size="size3"
        >
          {children}
        </Text>
      </>
    )
);

Button.displayName = 'Button';

Button.propTypes = {
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * HTML markup to be rendered
   */
  as: PropTypes.oneOf(['button', 'a']),
  /**
   * Children to be rendered inside component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Button fills the parent component's width
   */
  full: PropTypes.bool,
  /**
   * Renders an icon as children
   */
  icon: PropTypes.object,
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * `href` HTML attribute used when `as` prop is set to `a`
   */
  href: PropTypes.string,
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * `type` HTML attribute, default is `button`
   */
  htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),
};

export default Button;
